
type API_ERROR_TYPE = {
	status: string;
	message: string;
	// biome-ignore lint/suspicious/noExplicitAny: Multi, Single 모두 대응불가
	data: any;
};

type API_ERROR_FORM_TYPE = {
	field: string;
	reason: string;
	value: string;
};

class CommonError extends Error {
	status: string;
	data: string | API_ERROR_FORM_TYPE[];

	constructor({status, message, data}: API_ERROR_TYPE) {
		super(message);
		this.name = this.constructor.name;
		this.status = status;
		this.data = data;

		Error.captureStackTrace(this, this.constructor);
	}
}

export default CommonError;